export var CallStatus;
(function (CallStatus) {
    CallStatus["STARTED"] = "started";
    CallStatus["COMPLETED"] = "completed";
    CallStatus["ANALYZED"] = "analyzed";
})(CallStatus || (CallStatus = {}));
export const defaultCall = {
    transcripts: [],
    toolCalls: [],
    status: CallStatus.STARTED,
    organizationId: '',
    userId: '',
};
//# sourceMappingURL=CallsEntity.js.map